export default (() => {
    const jobForm = document.querySelector('form[id="4849217"]');
    const formPage = window.location.pathname.includes('/account/');
    
    if (jobForm && formPage) {
        document.querySelector('input[id="tfa_2238"]').value = window.currentUser.firstName;
        document.querySelector('input[id="tfa_2239"]').value = window.currentUser.lastName;
        document.querySelector('input[id="tfa_2241"]').value = window.currentUser.email;
        document.querySelector('input[id="tfa_2741"]').value = window.currentUser.phone;
        
        document.querySelectorAll('#tfa_2759-D, #tfa_2874-D, #tfa_2862-D').forEach((node) => {
            node.style.display = 'none';
        });

        const select = document.querySelector('select[id="tfa_2862"');
        const matchedOption = Array.from(select.options).find(el => el.textContent === window.currentUser.type);

        if (!matchedOption) return;
        select.value = matchedOption.value;
            
        // If 'Sponsoring' show first field else show the other. If no value, dont show any.
        if (select.value === 'tfa_2866') {
            document.querySelector('#tfa_2759-D').style.display = 'block';
        } else if (select.value) {
            document.querySelector('#tfa_2874-D').style.display = 'block';
        }
    }
})();